import { BaseHomeSchema } from '@space-core/datahub/hotmartClub'

type ConstructorParams = {
  arrivedFrom: string
}

export class ViewAccessEventSchema extends BaseHomeSchema {
  action: string
  private arrivedFrom: string
  private pushKind: string

  constructor({ arrivedFrom }: ConstructorParams) {
    super()

    this.action = 'view_access_event'
    this.pushKind = 'NOT_PUSH_EVENT'

    this.arrivedFrom = arrivedFrom
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      arrivedFrom: this.arrivedFrom,
      pushKind: this.pushKind
    }
  }
}
